<template>
    <Breadcrumbs main="Gallery" title="Gallery" />
    <div class="container-fluid">
        <div class="row">
            <gridGallery />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const gridGallery = defineAsyncComponent(() => import("@/components/theme/gallery/grid/gridGallery.vue"))
</script>